import { useState } from 'react';
import { Flex } from 'reflexbox';

import * as graphql from '@treams/treams-network';
import { AddIcon, IconButton, Popover } from '@treams/treams-ui';

import CreateGroupRole from './CreateGroupRole';
import CreateUserRole from './CreateUserRole';

export default function RolePlaceholder(props: {
	user: graphql.User;
	type: 'user' | 'group';
	inverse?: boolean;
	refetch: () => Promise<any>;
}) {
	const [visible, setVisible] = useState(false);

	return (
		<Popover.Target
			visible={visible}
			contents={
				props.type === 'user' ? (
					<CreateUserRole
						user={props.user}
						inverse={props.inverse}
						refetch={props.refetch}
						onCancel={() => setVisible(false)}
						onCreate={() => setVisible(false)}
					/>
				) : (
					<CreateGroupRole
						user={props.user}
						refetch={props.refetch}
						onCancel={() => setVisible(false)}
						onCreate={() => setVisible(false)}
					/>
				)
			}
			onDismiss={() => setVisible(false)}
		>
			<Flex height={48} alignItems="center" justifyContent="center">
				<IconButton type="secondary" icon={<AddIcon />} onClick={() => setVisible(true)} />
			</Flex>
		</Popover.Target>
	);
}
